/*
 * Shared constants for the Demo Environment Management page (/demo-env-mgmt).
 *
 * Predefined ids (projects, datasources, CSQ service accounts) and the authorized-users allowlist
 * are backend-managed (see `demoEnvMgmtApi.js` / quality-service's `demo-env-mgmt` module) — this
 * file only keeps the constants that describe the tool's fixed shape (hosts, entity types,
 * actions), not any predefined/editable data.
 */

// Fixed hosts (production). Tokens must be issued for this environment.
export const AUTH_HOST = 'auth.csq.io';
export const API_HOST = 'webapi.contentsquare.com';


// Entity types this page can operate on. "all" is a composite entity type
// (see `deleteAllEntityTypes`/`createAllEntityTypes` in csqEntityHandlers.js)
// that only supports "create"/"delete"/"resync" (mirroring sales-demo-env-setup's
// create-all.js/delete-all.js).
export const ENTITY_TYPES = [
  { value: 'mappings', label: 'Mappings', level: 'datasource' },
  { value: 'zonings', label: 'Zonings', level: 'datasource' },
  { value: 'segments', label: 'Segments', level: 'datasource' },
  { value: 'properties', label: 'Properties', level: 'datasource' },
  { value: 'charts', label: 'Charts', level: 'project' },
  { value: 'dashboards', label: 'Dashboards', level: 'project' },
  { value: 'all', label: 'All entity types', level: 'both' },
];

// Entity types whose "create" action is always replicated dynamically from the Source (see the
// build/run*CreateFromSourceOperations helpers in entities-tab.js) instead of a hand-edited JSON
// payload. Used to gate the manual "Create payload" editor (action-section.js) and the config-reset
// effect (entities-tab.js) — every OTHER entity type (currently just "charts") still uses the
// manual payload editor, since it has no source-replication flow built for it yet.
export const ENTITY_TYPES_WITH_SOURCE_REPLICATION = ['mappings', 'zonings', 'segments', 'properties', 'dashboards'];


// Actions available per entity type (filtered further in the UI, see
// `availableActions` in entities-tab.js). "resync" (Resync) is a single-step
// delete-then-recreate action available for every entity type, including the
// composite "all" — if it fails partway through, Target is left with
// whatever finished deleting/recreating so far (see the warnings logged by
// the `resync`/`resync-all` handleConfirm branches in entities-tab.js);
// simply re-running Resync (or Create) finishes the job.
export const ACTIONS = [
  { value: 'list', label: 'List' },
  { value: 'create', label: 'Create' },
  { value: 'delete', label: 'Delete' },
  { value: 'resync', label: 'Resync (Delete+Create)' },
];
